import React from "react";
import { Link } from "@tanstack/react-router";
import { Check } from "lucide-react";

export interface StepperProps {
  steps: {
    href: string;
    target?: string;
    title: string;
    description: string;
    items?: string[];
    completed: boolean;
    error?: string;
  }[];
}

export const Stepper = (props: StepperProps) => {
  return (
    <div className="flex flex-col">
      {props.steps.map((step, idx) => (
        <div key={idx} className="mb-8 flex items-start last:mb-0">
          <div className="flex flex-col items-center">
            <div
              className={[
                "flex h-8 w-8 items-center justify-center rounded-full border border-solid text-gray-600",
                step.completed
                  ? "border-lime-600 bg-lime-50 text-lime-600"
                  : "border-gray-200 bg-white",
              ].join(" ")}
            >
              {step.completed ? <Check /> : idx + 1}
            </div>
            {idx < props.steps.length - 1 && (
              <div className="w-px flex-1 bg-gray-200"></div>
            )}
          </div>
          <Link
            to={step.href}
            target={step.target}
            className="hover:text-brand-700 group ml-4 flex flex-1 cursor-pointer flex-col gap-2"
          >
            <h2 className="text-text-primary group-hover:text-brand-800 font-medium group-hover:underline">
              {step.title}
            </h2>
            {!step.completed && (
              <div className="">
                <p className="text-text-secondary">{step.description}</p>
                {step.items && (
                  <ul className="text-text-tertiary mt-2 list-inside list-disc space-y-1 text-sm">
                    {step.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
            {step.error && (
              <div className="mt-2 rounded bg-red-50 p-2 text-xs text-red-400">
                {step.error}
              </div>
            )}
          </Link>
        </div>
      ))}
    </div>
  );
};
